import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Spin, Tooltip } from "antd";
import { useMemo } from "react";
import CollectionZoneTimeline from "./CollectionZoneTimeline";
import { linhasDasCategorias } from "./timelineDaV2";

export default function CollectionsTimeLineWrapper({
  linhas,
  isLoading,
  error,
  selectedZones,
  selectedCollections,
  selectedDateRange,
}) {
  const linhasFiltradas = useMemo(
    () => linhasDasCategorias(linhas, selectedCollections),
    [linhas, selectedCollections]
  );

  return (
    <Card
      title={
        <>
          {"Timeline de Categorias por Zona"}
          <Tooltip
            title={
              "A intensidade da cor representa o faturamento: quanto mais escura, maior o faturamento médio diário."
            }>
            <InfoCircleOutlined style={{ marginLeft: 10 }} />
          </Tooltip>
        </>
      }
      align="center"
      style={{
        width: "85%",
      }}
      bodyStyle={{
        overflow: "auto",
        padding: "24px",
        margin: 0,
        maxHeight: "600px",
      }}
      styles={{
        header: { backgroundColor: "var(--ouran-card-header-bg)" },
        body: {
          display: "flex",
          flexDirection: "column",
        },
      }}>
      <div
        style={{
          flex: 1,
          width: "100%",
          minWidth: "500px",
        }}>
        {isLoading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "50px",
            }}>
            <Spin size="large" />
          </div>
        )}
        {(linhasFiltradas || error) && (
          <CollectionZoneTimeline
            collectionsData={linhasFiltradas ?? []}
            error={error}
            appliedZones={selectedZones}
            selectedDateRange={selectedDateRange}
          />
        )}
      </div>
    </Card>
  );
}
